export const removeEmptyFields = (obj, emptyValues = [null, undefined, '']) => Object.fromEntries(Object.entries(obj).filter(([, v]) => !emptyValues.includes(v)));
